@if (viewModel$ | async; as viewModel) {

    @if (isLoading()) {
        <div class="stretch-loader">
            <mat-spinner></mat-spinner>
        </div>
    } @else {

        <div echarts [options]="viewModel.chartOptions" class="chart-container"></div>

    }

} @else {
    <div class="stretch-loader">
        <mat-spinner></mat-spinner>
    </div>
}